import * as types from "../types/shiftCashier"
import { store } from "../store"

export const openShift = (startingCash, shiftId) => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.OPEN_SHIFT,
    shiftId,
    startingCash,
    accountId
  }
}

export const addPaidIn = (paidIn) => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.ADD_PAID_IN,
    paidIn,
    accountId
  }
}

export const addPaidOut = (paidOut) => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.ADD_PAID_OUT,
    paidOut,
    accountId
  }
}

export const addRefundToShift = (
  totalRefund,
  taxRefund,
  discountRefund
) => {

  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.ADD_REFUND,
    totalRefund,
    taxRefund,
    discountRefund,
    accountId
  }
}

export const addNewShiftOrder = (newShiftOrder) => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.ADD_NEW_SHIFT_ORDER,
    newShiftOrder,
    accountId
  }
}

export const clearShift = () => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.CLEAR_SHIFT,
    accountId
  }
}

export const increaseShiftQueueNumber = (orderId) => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.INCREASE_SHIFT_QUEUE_NUMBER,
    accountId,
    orderId
  }
}

export const updateShiftQueueNumber = (previousOrderId, newOrderId) => {
  const accountId =
    store.getState().userAccountInfo._id

  return {
    type: types.UPDATE_SHIFT_QUEUE_NUMBERS,
    accountId,
    previousOrderId,
    newOrderId
  }
}